import api from "../../api";

const state = {
  profileData: {}
};

const getters = {};

const mutations = {
  addProfile(state, data) {
    state.profileData = data;
  }
};

const actions = {
  userProfile({ commit, rootState, rootGetters }) {
    return new Promise((resolve, reject) => {
      commit("make_request", null, { root: true });
      api({
        url: `profiles/${rootState.user.id}`,
        method: "GET",
        withCredentials: true,
        headers: {
          Authorization: rootGetters.authToken
        }
      })
        .then(resp => {
          commit("request_success", null, { root: true });
          resolve(resp);
        })
        .catch(err => {
          commit("request_error", null, { root: true });
          reject(err);
        });
    });
  },
  updateProfile({ commit, rootState, rootGetters }, user) {
    return new Promise((resolve, reject) => {
      commit("make_request", null, { root: true });
      api({
        url: `profiles/${rootState.user.id}`,
        method: "PUT",
        withCredentials: true,
        data: user.data,
        headers: {
          Authorization: rootGetters.authToken
        }
      })
        .then(resp => {
          commit("request_success", null, { root: true });
          resolve(resp);
        })
        .catch(err => {
          commit("request_error", null, { root: true });
          reject(err);
        });
    });
  },

  getTalentProfile({ commit, rootGetters }) {
    return new Promise((resolve, reject) => {
      commit("make_request", null, { root: true });
      api({
        url: `talents/profiles`,
        method: "GET",
        withCredentials: true,
        headers: {
          Authorization: rootGetters.authToken
        }
      })
        .then(resp => {
          commit("request_success", null, { root: true });
          resolve(resp);
        })
        .catch(err => {
          commit("request_error", null, { root: true });
          reject(err);
        });
    });
  }
};

export const profiles = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
